import { mapFacetToActive } from '@search/utils';
import { SearchActions } from '../actions';
import { SearchActiveFacetsAction } from '../actions/active-facets.actions';
import { SearchSelectedFacetsAction } from '../actions/selected-facets.actions';
import { SearchState } from '../search-state';

export const initialState: SearchState['selectedFacets'] = [];

export function reducer(
  state: SearchState['selectedFacets'] = initialState,
  action: SearchSelectedFacetsAction | SearchActiveFacetsAction,
): SearchState['selectedFacets'] {
  switch (action.type) {
    case SearchActions.TOGGLE_FACET:
    case SearchActions.TOGGLE_SELECTED_FACET: {
      const {
        payload: { facet, value, force },
      } = action;
      const newState = [...state];
      const index = state.findIndex(
        (selectedFacet) => selectedFacet.code === facet.code && selectedFacet.value.code === value.code,
      );

      if (index !== -1) {
        if (force !== true) {
          return [...state.slice(0, index), ...state.slice(index + 1)];
        }
      } else {
        if (force !== false) {
          newState.push(mapFacetToActive(facet, value));
        }
      }

      return newState;
    }

    case SearchActions.SET_FACET_VALUE:
    case SearchActions.SET_SELECTED_FACET_VALUE: {
      const {
        payload: { facet, value },
      } = action;

      const newState = [...state];

      const index = state.findIndex(({ code }) => code === facet.code);
      const selectedFacet = mapFacetToActive(facet, { name: value.toString(), code: value.toString() });

      if (index !== -1) {
        newState[index] = selectedFacet;
      } else {
        newState.push(selectedFacet);
      }

      return newState;
    }

    case SearchActions.SET_FACET_RANGE_VALUE:
    case SearchActions.SET_SELECTED_FACET_RANGE_VALUE: {
      const {
        payload: { facet, value },
      } = action;

      const newState = state.filter(({ code }) => code !== facet.code);

      value
        .filter((v) => v != null)
        .map((v) => (v as number).toString())
        .forEach((v) => newState.push(mapFacetToActive(facet, { name: v, code: v })));

      return newState;
    }

    case SearchActions.CLEAR_SELECTED_FACETS: {
      return state;
    }

    case SearchActions.CLEAR_FACET_VALUE: {
      const {
        payload: { facet },
      } = action;

      return state.filter(({ code }) => code !== facet.code);
    }

    case SearchActions.CLEAR_ALL_FACETS: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
